export default "__VITE_ASSET__c491b85a__"